module.exports = __webpack_public_path__ + "fr.svg?1827a83fd94f3a9538c85efed7386856";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/fr.svg
// module id = 1427
// module chunks = 27